import React, { useState } from "react";
import ImagePickerPanel from "./ImagePickerPanel";

function ImagePicker({
    trigger,
    onSelect,
    many = false,
    defaultTab = "collection",
}) {
    const [open, setOpen] = useState(false);

    return (
        <>
            <span onClick={() => setOpen(true)}>
                {trigger || <button>Image Picker</button>}
            </span>

            <ImagePickerPanel
                open={open}
                onClose={() => setOpen(false)}
                onSelect={onSelect}
                many={many}
            />
        </>
    );
}

export default ImagePicker;
